import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Chart from 'react-apexcharts/core';
// Tree-shaken ApexCharts: only register what this chart uses
import 'apexcharts/donut';
import 'apexcharts/features/legend';
import { useTranslation } from 'react-i18next';
import styles from './DashboardWalletDistribution.module.css';
export default function DashboardWalletDistribution({ data }) {
    const options = {
        colors: ['#526AF2', '#C6CFFF', '#FE532D', '#FBC506', '#0EDC97', '#F252E2'],
        dataLabels: {
            enabled: false,
        },
        plotOptions: {
            pie: {
                customScale: 1,
                donut: {
                    labels: {
                        show: false,
                        total: {
                            show: false,
                            showAlways: false,
                            label: 'Total',
                            fontSize: '18px',
                            fontFamily: 'Roboto',
                            fontWeight: 500,
                            color: '#4F67F3',
                        },
                    },
                },
            },
        },
        labels: data === null || data === void 0 ? void 0 : data.portfolio.map((invest) => invest.society.substring(0, 25)),
        legend: {
            formatter(seriesName, opts) {
                var _a;
                return `${seriesName}     (${Math.round((((_a = opts === null || opts === void 0 ? void 0 : opts.w.globals.series[opts.seriesIndex]) !== null && _a !== void 0 ? _a : 0) * 100) / ((data === null || data === void 0 ? void 0 : data.balance) || 1))}%)`;
            },
            itemMargin: {
                horizontal: -10,
                vertical: 5,
            },
        },
    };
    const { t } = useTranslation();
    return (_jsxs("section", { className: styles.distribution, children: [_jsx("h3", { className: styles.title, children: t('dashboard.wallet.repartition') }), _jsx("div", { children: _jsx(Chart, { series: data === null || data === void 0 ? void 0 : data.portfolio.map((invest) => invest.amount), type: "donut", width: window.innerWidth > 1600 ? '500' : '350', options: options }) })] }));
}
